import { useState, useEffect } from 'react';

/**
 * Custom hook for managing mobile sidebar state
 * Automatically handles mobile detection and sidebar auto-toggle
 */
export const useMobileSidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768; // md breakpoint (768px)
      setIsMobile(mobile);
      
      // Auto-toggle behavior:
      // - On mobile: close sidebar by default
      // - On desktop: open sidebar by default
      if (mobile) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    // Initial check
    checkMobile();
    
    // Listen for window resize
    window.addEventListener('resize', checkMobile);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Toggle sidebar manually
  const toggleSidebar = () => {
    setIsSidebarOpen(prev => !prev);
  };

  // Close sidebar (useful for mobile when navigating)
  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  // Open sidebar
  const openSidebar = () => {
    setIsSidebarOpen(true);
  };

  return {
    isSidebarOpen,
    isMobile,
    toggleSidebar,
    closeSidebar,
    openSidebar
  };
};
